<template>
  <div class="app-container member-list">
    <div class="search-field">
      <el-date-picker
        class="search-field-daterange"
        v-model="searchedDateRange"
        type="daterange"
        value-format="yyyy-MM-dd"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        @change="selectDate"
        :clearable=false
        size="small">
      </el-date-picker>
      <el-select class="search-field-datetype" placeholder="状态" @change="getAnalysisSummary" v-model="dataType" size="medium">
      	<el-option
					v-for="item in dataTypes"
					:key="item.value"
					:label="item.label"
					:value="item.value">
      	</el-option>
      </el-select>
    </div>
    <basic-container class="member-list-container">
      <avue-crud
				ref="crud"
				:option="tableOption"
				:data="list"
				:table-loading="listLoading"
				@refresh-change="getAnalysisSummary"
				@sort-change="handleSortChange">
        <template slot="menuLeft">
          <el-button 
                      v-if="permissions.analysis_tag_export"
                      class="filter-item"
                      @click="handleExport()"
                      size="small"
                      type="primary"
                      :loading="exportLoading"
                      icon="el-icon-download">{{exportName}}
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
  import {getPostTagStatisticsSummaryData, exportPostTagStatisticsSummaryData} from '@/api/analysis/postTagAnalysis'
  import { exporting } from '@/util/exportUtil'
  import {tableOption} from '@/const/crud/analysis/postTagAnalysis'
  import { formatDate } from '@/util/date';
  import {mapGetters} from "vuex";

  export default {
    name: "table_member",
    data() {
      return {
        exportLoading: false,
        exportName: "导出",
        list: [],
        tableOption: tableOption,
        listLoading: false,
        searchedDateRange: [],
        dataTypes: [
          {
            label: '按天',
            value: 'daily'
          },
          {
            label: '按月',
            value: 'month'
          },
          {
            label: '按总量',
            value: 'total'
          }
        ],
        dataType: 'total'
      };
    },
    computed: {
      ...mapGetters(['permissions']),
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        this.searchedDateRange.push(formatDate('YYYY-mm-dd', start))
				this.searchedDateRange.push(formatDate('YYYY-mm-dd', end))

	      this.getAnalysisSummary()
      },
      selectDate(e) {
        var nDays = this.daysBetween(this.searchedDateRange[0], this.searchedDateRange[1]);
        if(nDays > 100 && this.dateType != 'total') {
          this.dataType = 'total'
				}

				this.getAnalysisSummary()
      },
      daysBetween(sDate1,sDate2){
        //Date.parse() 解析一个日期时间字符串，并返回1970/1/1 午夜距离该日期时间的毫秒数
        var time1 = Date.parse(new Date(sDate1));
        var time2 = Date.parse(new Date(sDate2));
        var nDays = Math.abs(parseInt((time2 - time1)/1000/3600/24)) + 1;
        return nDays;
      },
      getAnalysisSummary() {
				let param = {}
        param.fromDate = this.searchedDateRange[0]
        param.toDate = this.searchedDateRange[1]
				param.type = this.dataType

        this.listLoading = true
        getPostTagStatisticsSummaryData(param).then(response => {
          this.list = response.data.data
          this.listLoading = false
        });
      },
      handleExport() {
				let param = {}
        param.fromDate = this.searchedDateRange[0]
        param.toDate = this.searchedDateRange[1]
				param.type = this.dataType

        exportPostTagStatisticsSummaryData(param).then(response => {
          if (response.status === 200 && response.data && response.data.data) {
            this.exportLoading = true
            this.exportName = "导出中..."
            exporting(response.data.data, this.exportCallback)
          } else {
            this.$message({
              message: '信息导出失败',
              type: 'warning',
              showClose: true,
            });
          }
        });
      },
      exportCallback(result) {
        this.exportLoading = false
        this.exportName = "导出"
        if (result) {
          this.$message({
            showClose: true,
            message: '导出完成',
            type: 'success'
            })
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.search-field{
  display: flex;
  padding-bottom: 8px;
  padding-left: 10px;
  flex-direction: row;
  &-daterange {
    width: 400px!important;
    height: 36px;
  }
  &-datetype {
    padding-left: 10px;
    width: 150px!important;
  }
	&-export {
		float: right;
		margin-left: 10px;
		margin-right: 10px;
	}
}
</style>
